export default "__VITE_ASSET__BT9MiqaO__"